import { Component, OnInit } from '@angular/core';
import { AppService } from '.../../../src/app/modules/shared/services/geral/app.service';
import { SelectItem } from 'primeng/api';
import { FilterUtils } from '../../../shared/utils/filterutils';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cadastro-poderes',
  templateUrl: './cadastro-poderes.component.html',
  styleUrls: ['./cadastro-poderes.component.css']
})
export class CadastroPoderesComponent implements OnInit {

  constructor(public svc: AppService, private router: Router, private tl: TranslateService) {
    //Carrega as Traduções Gerais da Tela
    this.svc.sbGetTraducaoAuto("geral.mensagens").subscribe((resp) => {
      this.traducao.geral = resp;
    });

    this.svc.sbGetTraducaoAuto("cadastro_poderes_tabela").subscribe((resp) => {
      this.traducao.tabela = resp;
    });
  }

  public tipo_manutencao: string;
  public cols: any[];
  public clientes: any[];
  public novo_cliente: any = {
    ind_assina_contrato: "",
    cnpj: "",
    razao_social: ""
  };
  public traducao: any = {
    geral: "",
    tabela: ""
  }
  public spinTable = false;
  public spinClienteCRUD = false;

  public sbRetornarFiltros(lista: any[], column: string): any {
    var retorno = [];

    if (lista) {
      for (let i = 0; i < lista.length; i++) {
        retorno.push(lista[i][column]);
      }

      retorno = retorno.filter(function (value, index) { return retorno.indexOf(value) == index });

      for (let i = 0; i < retorno.length; i++) {
        retorno[i] = { label: retorno[i], value: retorno[i] }
      }
    }

    return retorno;
  }

  public sbCarregarIdioma(dados) {
    this.cols = [
      { type: 'text-duplo', filter: true, filter_type: 'multi-select', header: dados.cliente, field: 'nome_cliente', size: '80%', coluna_aux: 'documento_cliente' },
      { type: 'hide', filter: false, filter_type: 'multi-select', header: '', field: 'documento_cliente', size: '0%' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: dados.assinatura, field: 'ind_assinatura', size: '20%' },
    ];
  }

  public limparForm(f: NgForm, data) {
    f.reset();

    var that = this;
    setTimeout(() => {
      if (data == null) {
        that.novo_cliente = {
          ind_assina_contrato: "",
          cnpj: "",
          razao_social: ""
        };
      } else {
        that.novo_cliente = data;
      }
    }, 100);
  }

  public sbAbrirCliente(event: Event, f: NgForm): void {
    try {
      this.tipo_manutencao = "I";
      this.limparForm(f, null);

      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  };

  public processarCliente(f: NgForm) {
    try {
      //Verifica se o FOrmulário está Válido
      var funcValida: boolean = false;
      if (f.valid) {
        if (this.novo_cliente.cnpj.length <= 14) {
          funcValida = this.svc.validarCPF(this.novo_cliente.cnpj)
        } else {
          funcValida = this.svc.validarCNPJ(this.novo_cliente.cnpj)
        }
        if (funcValida){
          this.spinClienteCRUD = true;
          this.svc.CadastroPoderesInluir(this.novo_cliente);
          this.svc.CadastroPoderesInluido().subscribe((resp) => {
            if (resp == false) this.spinClienteCRUD = false;
            else if (resp != null) {
              this.svc.sbFecharModal("modalCliente");
              this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.cliente_incluido"));
              this.spinClienteCRUD = false;
              this.carregarClientes();
            }
          });
        } else {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.cnpj"));
        }
      } else {
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("geral.mensagens.campos_obrigatorios"));
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public sbRedirecionar(data) {
    try {
      this.router.navigate(['/cadastro-poderes-cliente', JSON.stringify(data)], { skipLocationChange: true });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public carregarClientes(){
    try{
       //Carrega os Dados da Tabela Tipos de Processo
       this.spinTable = true;
       this.svc.CadastroPoderesPesquisar();
       this.svc.CadastroPoderes().subscribe((resp) => {
         if (resp == false) this.spinTable = false;
         else if (resp != null) {
           this.spinTable = false;
           this.clientes = resp.clientes;
         }
       });
    } catch(e){
      throw e;
    }
  }

  ngOnInit() {

    try {
      this.sbCarregarIdioma(this.traducao.tabela);
      this.carregarClientes();

      //É chamado sempre que o Idioma for Mudado
      this.svc.sbGetTraducaoAuto("cadastro_poderes_tabela").subscribe((resp) => {
        this.sbCarregarIdioma(resp);
      });

      FilterUtils['custom'] = (value, filter): boolean => {
        if (filter === undefined || filter === null || filter.trim() === '') {
          return true;
        }

        if (value === undefined || value === null) {
          return false;
        }

        return parseInt(filter) > value;
      };

    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }

  }
}
